// src/components/InfoTooltip.js
export default function InfoTooltip({ text }) {
    if (!text) return null;

    return (
        <span
            className="ml-1 text-[11px] align-middle text-zinc-400 cursor-help select-none"
            title={text}
        >
            ⓘ
        </span>
    );
}
